import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectTripDelayStep = (state) => state.get('tripDelayStep');

const makeSelectTripDelayStep = () => createSelector(
  selectTripDelayStep,
  (selectTripDelaySate) => ({
    schoolNameForDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'schoolNameForDelay']),
      ''
    ),

    travelDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'travelDelay']),
      ''
    ),

    detailsRegardingYourTripDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'detailsRegardingYourTripDelay']),
      ''
    ),

    companyNameTravelDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'companyNameTravelDelay']),
      ''
    ),

    addressTravelDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'addressTravelDelay']),
      ''
    ),

    cityTravelDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'cityTravelDelay']),
      ''
    ),

    stateTravelDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'stateTravelDelay']),
      ''
    ),

    zipCodeTravelDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'zipCodeTravelDelay']),
      ''
    ),

    contactTravelDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'contactTravelDelay']),
      ''
    ),

    phoneNumberTravelDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'phoneNumberTravelDelay']),
      ''
    ),

    includedInPackageForDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'includedInPackageForDelay']),
      ''
    ),

    dateOfInitialPaymentDeposit: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'dateOfInitialPaymentDeposit']),
      ''
    ),

    dateYouWereDueToDepart: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'dateYouWereDueToDepart']),
      ''
    ),

    timeYouWereDueToDepart: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'timeYouWereDueToDepart']),
      ''
    ),

    dateTripWasDelayed: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'dateTripWasDelayed']),
      ''
    ),

    dateDelayEnded: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'dateDelayEnded']),
      ''
    ),

    dateDelayEndedForDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'dateDelayEndedForDelay']),
      ''
    ),

    dateTripWasDelayedWithTravelSupplier: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'dateTripWasDelayedWithTravelSupplier']),
      ''
    ),

    dateYouActuallyDeparted: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'dateYouActuallyDeparted']),
      ''
    ),

    timeYouActuallyDeparted: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'timeYouActuallyDeparted']),
      ''
    ),

    // New Question 1
    areYouClaimingForTripDelayPerDay: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'areYouClaimingForTripDelayPerDay']), ''),

    // New Question 2
    areYouClaimingForKennelFeesAtHome: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'areYouClaimingForKennelFeesAtHome']), ''),

    // New Question 3
    areYouClaimingForKennelFeesOnTrip: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'areYouClaimingForKennelFeesOnTrip']), ''),

    delayInformationItems: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'delayInformationItems']) && selectTripDelaySate.getIn(['form', 'delayInformationItems']).toJS(),
      ''
    ),
    insuredsTripDelay: mapWithDefault(
      selectTripDelaySate,
      () => selectTripDelaySate.getIn(['form', 'insuredsTripDelay']) && selectTripDelaySate.getIn(['form', 'insuredsTripDelay']).toJS(),
      ''
    ),

    companyNameLoss: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'currentAmountOfLoss']), ''),
    haveYouReceivedReimbursement: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(selectTripDelaySate, () => selectTripDelaySate.getIn(['form', 'dateReimbursementReceived']), ''),
  })
);

const makeSelectTripDelayStepErrors = () =>
  createSelector(selectTripDelayStep, (state) => state.get('errors'));

export {
  makeSelectTripDelayStep,
  makeSelectTripDelayStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripDelayStep/selectors.js